<div class="training-group-training-requirement-container">
  <mat-accordion
    *ngIf="
      trainingGroupTrainingRequirementSkeletons &&
      trainingGroupTrainingRequirementSkeletons.length > 0
    "
  >
    <mat-expansion-panel>
      <mat-expansion-panel-header>Training Events</mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-accordion>
          <mat-expansion-panel
            *ngFor="
              let trainingGroupTrainingRequirement of trainingGroupTrainingRequirementSkeletons
            "
            (opened)="onOpened(trainingGroupTrainingRequirement.trainingGroupTrainingRequirementId)"
          >
            <mat-expansion-panel-header>
              {{ trainingGroupTrainingRequirement.eventTitle }}
              <span *ngIf="trainingGroupTrainingRequirement.isDeleted">&nbsp;(Deleted)</span>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <div
                *ngIf="
                  trainingGroupTrainingRequirementAuditLoading;
                  else trainingGroupTrainingRequirementAuditsLoaded
                "
              >
                Loading...
              </div>
              <ng-template #trainingGroupTrainingRequirementAuditsLoaded>
                <div
                  *ngIf="
                    trainingGroupTrainingRequirementAudits &&
                      trainingGroupTrainingRequirementAudits.length > 0;
                    else noTrainingGroupTrainingRequirementAudits
                  "
                >
                  <sd-portal-audit-detail-list
                    [audits]="trainingGroupTrainingRequirementAudits"
                    (nextPage)="
                      onNextPage(
                        trainingGroupTrainingRequirement.trainingGroupTrainingRequirementId
                      )
                    "
                  >
                  </sd-portal-audit-detail-list>
                </div>
                <ng-template #noTrainingGroupTrainingRequirementAudits>
                  No audit records for this training event
                </ng-template>
              </ng-template>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
